import { RunStateTransition } from "types/generated";
import ExplainRunButton from "components/Run/elements/ExplainRunButton";

import FailedEntry from "../entries/FailedEntry";
import { getRunStateTransitionId } from "./getRunStateTransitionId";
import { RunEntryContext } from "../types";

export const createFailedEntry = (
  { timestamp, note, stateVersion }: RunStateTransition,
  { stackId, runId }: RunEntryContext
) => (
  <FailedEntry
    key={getRunStateTransitionId(timestamp, stateVersion)}
    timestamp={timestamp}
    note={note}
  >
    <ExplainRunButton stackId={stackId} runId={runId} />
  </FailedEntry>
);
